import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@infrastructure/api/client'
import { ENDPOINTS } from '@infrastructure/api/endpoints'
import { mapTenantsResponse } from '@application/services/tenantMapper'
import type { Tenant } from '@domain/entities'
import { tenantActions } from '@store/tenantStore'
import { TENANT_QUERY_KEYS } from './queryKeys'

const TENANT_PAGE_SIZE = 100

export const useTenants = () => {
  return useQuery({
    queryKey: TENANT_QUERY_KEYS.list,
    queryFn: async () => {
      const tenants: Tenant[] = []
      let totalCount = 0
      let page = 1
      do {
        const raw = await httpClient.get(ENDPOINTS.USM.ADMIN.TENANTS.LIST, {
          params: { page: String(page), pageSize: String(TENANT_PAGE_SIZE) },
        })
        const result = mapTenantsResponse(raw)
        if (!result) throw new Error('Failed to parse tenants response')
        if (result.items.length === 0) break
        tenants.push(...result.items)
        totalCount = result.totalCount
        page += 1
      } while (tenants.length < totalCount)
      tenantActions.setTenants(tenants)
      return tenants
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })
}
